import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { switchMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { Action } from 'redux-actions';

import { getIsRefreshQRCodeExists, getRefreshQRCode } from '@src/services/qrcode';
import { GET_IS_REFRESH_QR_CODE_EXISTS_CALL, GET_REFRESH_QR_CODE_CALL } from '../types/qrcode';
import {
	getIsRefreshQRCodeExistsDone,
	getIsRefreshQRCodeExistsFail,
	getRefreshQRCodeDone,
	getRefreshQRCodeFail,
} from '../actions/qrcode';

export const getRefreshQRCodeEpic = (
	action$: Observable<Action>,
): Observable<Action> => action$.pipe(
	ofType(GET_REFRESH_QR_CODE_CALL),
	switchMap(
		({ payload }) => fromPromise(getRefreshQRCode(payload)).pipe(
			switchMap(res => {
				if (typeof payload.onSuccess === 'function') payload.onSuccess(res);
				return of(getRefreshQRCodeDone({ res }));
			}),
			catchError(error => {
				if (typeof payload.onError === 'function') payload.onError(error?.response || error);
				return of(getRefreshQRCodeFail({ error }));
			}),
		),
	),
);

export const getIsRefreshQRCodeExistsEpic = (
	action$: Observable<Action>,
): Observable<Action> => action$.pipe(
	ofType(GET_IS_REFRESH_QR_CODE_EXISTS_CALL),
	switchMap(
		({ payload }) => fromPromise(getIsRefreshQRCodeExists(payload)).pipe(
			switchMap(res => {
				if (typeof payload.onSuccess === 'function') payload.onSuccess(res);
				return of(getIsRefreshQRCodeExistsDone({ res }));
			}),
			catchError(error => {
				if (typeof payload.onError === 'function') payload.onError(error.response);
				return of(getIsRefreshQRCodeExistsFail({ error }));
			}),
		),
	),
);
